import React from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { useQuery, useMutation, useParameterizedQuery } from 'react-fetching-library';
import SendIcon from '@mui/icons-material/Send';
import { getFormSectionsAction, submitFormAction, getHistoricDataByPeselAction, getFormMetaDataAction, getInitZSDataAction, getInitWRDataAction } from '../../services/request';
import { SectionPanel } from './SectionPanel';
import { createYupSchema, formatDateTime, formatDate, numberToPercent, getOptionIndex, addDays, isSingleEmptyObjectArray } from '../../services/functions';
import { useFullScreen, useDynamicInitAction, useDynamicQuery, useDidMountEffect } from '../../services/hooks';
import FormSentInfo from './FormSentInfo';
import { mapAndUpdateInitialValuesFromQueryParams, processChildrenParam, getClientInfo } from './functions';
import { useSelector } from 'react-redux';
import { FormStepper } from './FormStepper';

const olSteps = [
  {
    label: 'Dane podstawowe'

  },
  {
    label: 'Dane kontaktowe'
  },
  {
    label: 'Pozostałe informacje'
  }
];

const emptyEteps = [];

export const FormPanel = props => {
  const fullScreen = useFullScreen();
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { group } = useSelector(state => state.app);
  const { form, clientData, participantData, setIsHiddenSelectParticipant, boskieWakacje } = props;
  const { loading, payload, error } = useQuery(getFormSectionsAction(form.id));
  const { loading: metaLoading, payload: metaPayload, error: metaError } = useQuery(getFormMetaDataAction(form.id));
  const submitForm = useMutation(submitFormAction);
  const initAction = useDynamicInitAction(form.init_function);
  const initData = useDynamicQuery(initAction);
  const historicPeselAction = useParameterizedQuery(getHistoricDataByPeselAction);
  const [initialParamsData, setInitialParamsData] = React.useState({ resort: null, period: null });
  const formSteps = form && form.identifier == 'lato' ? olSteps : emptyEteps;

  // STEPPER
  const [activeStep, setActiveStep] = React.useState(1);
  const validateCurrentStep = async () => {
    const errors = await formik.validateForm();

    const currentStepFields = fields
      .filter(field => field.step === activeStep)
      .map(field => field.name);

    const stepErrors = Object.keys(errors).filter(key => currentStepFields.includes(key)
    );

    if (stepErrors.length > 0) {
      formik.setTouched(
        Object.fromEntries(
          stepErrors.map(key => [key, true])
        )
      );

      return false;
    }

    return true;
  };

  const goToNextStep = async () => {
    const isValid = await validateCurrentStep();

    if (isValid) {
      const { error, payload, status } = await submitForm.mutate({ ...formik.values, validate_only: true }, form.id, false, true);
      if (status !== 200) {
        alert(payload.message);
      } else {
        setActiveStep(activeStep + 1);
        setShowErrors(false);
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }, 0);
      }
    } else {
      setShowErrors(true);
    }
  };

  const goToPreviousStep = () => {
    setActiveStep(prev => Math.max(prev - 1, 0));
  };

  // ----

  if (props.form.identifier === 'zielone_szkoly') {
    const isZSForm = props.form.identifier === 'zielone_szkoly';

    const initParams = {
      preffered_resort: searchParams.get('preffered_resort') || '',
      period_length: searchParams.get('period_length') || '',
      package: searchParams.get('package') || '',
      promotion: searchParams.get('promotion') || '',
      zs_source_of_offer: searchParams.get('zs_source_of_offer') || '',
      voivodeship: searchParams.get('voivodeship') || '',
      county: searchParams.get('county') || '',
      commune: searchParams.get('commune') || '',
      city: searchParams.get('city') || '',
      school: searchParams.get('school') || '',
      notes: searchParams.get('notes') || '',
      form_version: props.form.version
    };

    const shouldFetchInitData = isZSForm && initParams.preffered_resort && initParams.period_length;

    const query = useQuery(
      shouldFetchInitData ? getInitZSDataAction(initParams) : null
    );

    React.useEffect(() => {
      if (shouldFetchInitData && !query.loading && !query.error && query.payload) {
        setInitialParamsData(query.payload);
      }
    }, [shouldFetchInitData, query.loading, query.error, query.payload]);
  };

  if (props.form.identifier === 'wyjazdy_rodzinne') {
    if (searchParams.get('resort')) {
      const resortParam = searchParams.get('resort') || '';
      const periodParam = searchParams.get('period') || '';

      const { loading: initDataLoading, payload: initDataPayload, error: initDataError } =
          useQuery(getInitWRDataAction(resortParam, periodParam));

      React.useEffect(() => {
        if (!initDataLoading && !initDataError) {
          const childrenData = processChildrenParam(searchParams.get('children'));
          setInitialParamsData({
            ...initDataPayload,
            ...childrenData
          });
        }
      }, [initDataLoading]);
    }
  }
  const [sections, setSections] = React.useState([]);
  const [prevSections, setPrevSections] = React.useState([]);
  const [fields, setFields] = React.useState([]);
  const [today, setToday] = React.useState(new Date());
  const [isFormSent, setIsFormSent] = React.useState(false);
  const [metaData, setMetaData] = React.useState([]);
  const [showErrors, setShowErrors] = React.useState(false);

  React.useEffect(() => {
    if (!error && !loading) {
      if (!_.isNil(form.init_function) && !_.isEmpty(initData.data)) {
        const sectionsToConst = _.cloneDeep(payload);
        if (boskieWakacje && sectionsToConst) {
          const parishId = sectionsToConst[1].fields.findIndex(item => item.name == 'parish');
          if (parishId) {
            sectionsToConst[1].fields[parishId].hide = false;
            sectionsToConst[1].fields[parishId].required = true;
          }
        }
        _.map(initData.data, (options, key) => {
          _.map(sectionsToConst, section => {
            const index = sectionsToConst.indexOf(section);
            sectionsToConst.splice(index, 1);
            _.map(section.fields, field => {
              if (field.name === key) {
                field.dynamicOptions = options;
              }
            });
            sectionsToConst.splice(index, 0, section);
          });
        });
        setSections(sectionsToConst);
        const fetchedFields = [];
        _.map(sectionsToConst, section => _.map(section.fields, obj => fetchedFields.push(obj)));
        setFields(fetchedFields);
      } else {
        const sectionsToConst = _.cloneDeep(payload);
        if (boskieWakacje && sectionsToConst) {
          const parishId = sectionsToConst[1].fields.findIndex(item => item.name == 'parish');
          if (parishId) {
            sectionsToConst[1].fields[parishId].hide = false;
            sectionsToConst[1].fields[parishId].required = true;
          }
        }
        setSections(sectionsToConst);
        const fetchedFields = [];
        _.map(payload, section => _.map(section.fields, obj => fetchedFields.push(obj)));
        setFields(fetchedFields);
      }
    }
  }, [loading]);

  React.useEffect(() => {
    if (!metaError && !metaLoading) {
      setMetaData(metaPayload.actions.GET);
    }
  }, [metaLoading]);

  const yupSchema = fields.reduce(createYupSchema, {});
  const validationSchema = Yup.object().shape(yupSchema);
  const initialValues = {};
  _.map(fields, obj => {
    if (obj.type === 'datetime') {
      initialValues[obj.name] = formatDateTime(today);
    } else if (obj.type === 'date') {

      if (_.isNil(participantData) || !_.isObject(participantData) || !obj.name.startsWith('birth_date')) {
        initialValues[obj.name] = null;
      } else if (participantData.hasOwnProperty(obj.name) && !_.isNil(participantData[obj.name])) {
        initialValues[obj.name] = formatDate(participantData[obj.name]);
      } else {
        initialValues[obj.name] = null;
      }

    } else if (obj.type === 'time') {
      initialValues[obj.name] = today;
    } else if (obj.type === 'bool') {
      initialValues[obj.name] = false;
    } else if (obj.type === 'multichoice' || obj.type === 'multicharwithchoice') {
      initialValues[obj.name] = [];
    } else if (obj.type === 'multichar') {
      initialValues[obj.name] = [{}];
    } else if (obj.type === 'radiochoice') {
      if (!obj.name.startsWith('participant_gender') || _.isNil(participantData) || _.isEmpty(clientData)) {
        if (['client_status', 'camp_recommended_by_client_friend'].includes(obj.name)) {
          initialValues[obj.name] = '';
        } else {
          initialValues[obj.name] = obj.options[0];
        }
      } else if (participantData.hasOwnProperty('gender') && !_.isNil(participantData.gender)) {

        if (participantData.gender === 'boy') {
          initialValues[obj.name] = obj.options[0];
        } else {
          initialValues[obj.name] = obj.options[1];
        }

      } else if (['client_status', 'camp_recommended_by_client_friend'].includes(obj.name)) {
        initialValues[obj.name] = '';
      } else {
        initialValues[obj.name] = obj.options[0];
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (obj.name.startsWith('guardian_') && !_.isNil(clientData) && !_.isEmpty(clientData)) {
        const key = obj.name.replace('guardian_', '');
        if (clientData.hasOwnProperty(key) && !_.isNil(clientData[key])) {
          initialValues[obj.name] = clientData[key];
        } else {
          initialValues[obj.name] = '';
        }
      } else if (obj.name.startsWith('participant_') && !_.isNil(participantData) && !_.isEmpty(participantData)) {
        const key = obj.name.replace('participant_', '');
        if (participantData.hasOwnProperty(key) && !_.isNil(participantData[key])) {
          initialValues[obj.name] = participantData[key];
        } else {
          initialValues[obj.name] = '';
        }
      } else {
        initialValues[obj.name] = '';
      }
    }
  });

  mapAndUpdateInitialValuesFromQueryParams(props.form.identifier, initialValues, searchParams);

  const resolveFieldValues = (values, fieldNamesToResolve) => {
    fieldNamesToResolve.forEach(fieldName => {
      if (fieldName in values) {
        const field = sections
          .flatMap(s => s.fields) // spłaszcza wszystkie pola z sekcji
          .find(f => f.name === fieldName); // znajduje pierwszy pasujący obiekt

        const selectedOption = field?.dynamicOptions?.find(
          o => o.id === values[fieldName]
        );
        if (selectedOption) {
          values[fieldName] = selectedOption.name;
        }
      }
    });
  };

  const handleSubmit = async values => {
    values.params_form = 'resort' in params;
    const testForm = values.testForm ? true : false;
    values.crm_id = searchParams.get('id');
    // Ta funkcja zmienia wartości ID na NAME z dynamicOptions
    resolveFieldValues(values, [
      'school_province',
      'school_county',
      'school_commune',
      'school_city',
      'school_name'
    ]);
    const { error, payload } = await submitForm.mutate(values, form.id, testForm);
    if (!error && payload.success === true) {
      if (['lato'].includes(props.form.identifier) && group !== 'employees') {
        navigate('/form-submitted', {
          state: {
            formId: form.id,
            identifier: form.identifier,
            formikValues: formik.values
          },
          replace: true
        });
      } else {
        setIsFormSent(true);
        if (_.isFunction(setIsHiddenSelectParticipant)) {
          setIsHiddenSelectParticipant(true);
        }
      }
    } else {
      alert(payload.message);
    }
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    validateOnChange: true, // wyłączyć to w razie gdyby za wolno chodził formularz
    validateOnMount: true,
    onSubmit: values => {
      handleSubmit({ ...values, client_info: getClientInfo() });
    }
  });

  const updateOptionsCallback = data => {
    const sectionsToConst = _.cloneDeep(sections);
    _.map(sectionsToConst, section => {
      const index = sectionsToConst.indexOf(section);
      sectionsToConst.splice(index, 1);
      _.map(data, (options, key) => {
        if (key.includes('_id')) {
          setFieldById(options, key);
        } else {
          _.map(section.fields, field => {
            if (field.name === key) {
              if (field.type == 'multichoice') {
                formik.setFieldValue(key, []);
              } else if (['discount', 'ol_discounts'].includes(field.name)) {
                formik.setFieldValue(key, [null, null, null, null, null]);

              } else if (field.type == 'multichar') {
                formik.setFieldValue(key, [{}]);
              } else {
                formik.setFieldValue(key, '');
              }
              field.dynamicOptions = options;
            }
          });
        }
      });
      sectionsToConst.splice(index, 0, section);

    });
    setSections(sectionsToConst);
  };

  const setFieldById = (val, key) => {
    const field_name = key.split('_')[0];
    formik.setFieldValue(field_name, val);
  };

  const yupRequiredFieldsCallback = (params, sectionId, optionIndex, newVal = null) => {
    // no póki co dla jednego parametru to robimy, nie wiem czy będzie więcej. Ta funkcja obsługuje choicefield, booleany i radiofieldy z dwoma opcjami
    // dla radiofield więcej niż jeden parametr
    // choice fieldy z opcją exists
    const fieldsToConst = _.cloneDeep(fields);
    const sectionsToConst = _.cloneDeep(sections);
    const section = _.filter(sectionsToConst, section => section.id === sectionId)[0];
    const index = sectionsToConst.indexOf(section);
    sectionsToConst.splice(index, 1);
    _.map(section.fields, field => {
      const yupField = _.find(fieldsToConst, obj => obj.id === field.id);
      const requiredObject = { type: 'required', params: ['To pole jest wymagane'] };
      const oneOf = {
        type: 'oneOf',
        params: [[true], 'Należy zaakceptować warunki']
      };

      const isFound = () => {
        if (!field.show_on || !_.isArray(params)) {
          return false;
        }

        const args = field.show_on.trim().split(' ')
          .map(show_on => show_on.replace(/\s/g, ''));

        return args.some(arg => params.includes(arg));
      };
      if (field.show_on && field.show_on.includes('exists') && isFound()) {
        // Sprawdzamy czy atrybut nadrzędny posiada jakąś wartość, jeśli nie to znaczy że pole nie jest wymagane
        if (newVal) {
          field.required = true;
          if (field.type == 'bool') {
            yupField.validations.push(oneOf);
          } else {
            yupField.validations.push(requiredObject);
          }
        } else {
          field.required = false;
          if (field.type == 'bool') {
            yupField.validations = _.filter(yupField.validations, obj => obj.type !== 'oneOf');
          } else {
            yupField.validations = _.filter(yupField.validations, obj => obj.type !== 'required');
          }
        }
      } else if (field.show_on && isFound() && !field.lock_required) {
        const args = field.show_on.trim().split(' ')
          .map(show_on => show_on.replace(/\s/g, ''));

        for (const arg of args) {
          const index = params.indexOf(arg);
          if (optionIndex == getOptionIndex(params[index])) {
            field.required = true;
            yupField.validations.push(requiredObject);
            break;
          } else {
            field.required = false;
            const vals = yupField.validations;
            yupField.validations = _.filter(vals, obj => obj.type !== 'required');
          }
        }

      } else if (field.show_on && field.show_on.includes('false')) {
        if (params) {
          field.required = false;
          const vals = yupField.validations;
          yupField.validations = _.filter(vals, obj => obj.type !== 'required');
        } else {
          field.required = true;
          yupField.validations.push(requiredObject);
        }
      } else if (field.show_on && field.show_on.includes('true')) {
        if (!params) {
          field.required = false;
          const vals = yupField.validations;
          yupField.validations = _.filter(vals, obj => obj.type !== 'required');
        } else {
          field.required = true;
          yupField.validations.push(requiredObject);
        }
      }
    });
    sectionsToConst.splice(index, 0, section);
    setSections(sectionsToConst);
    setFields(fieldsToConst);

    return sectionsToConst;
  };

  const bigFamilyCardCallback = (params, sectionId, optionIndex) => {
    yupRequiredFieldsCallback(params, sectionId, optionIndex);
    if (['lato'].includes(props.form.identifier)) {
      const toHidepromotionFields = [
        'quick_payment_promotion',
        'quick_payment_promotion_obj',
        'discount_code',
        'discount_code_promotions',
        'ol_discounts',
        'friends',
        'siblings'
      ];
      const toShowPromotionFields = [
        'discount_code',
        'discount_code_promotions',
        'ol_discounts'
      ];
      // Promocja szybkiej płatności dostępna jest tylko na 35+ dni przed rozpoczęciem turnusu
      if (formik.values.quick_payment_promotion_obj) {
        const metaDataCamp = metaData.camps.find(o => o.id == formik.values.camp);
        const today = new Date();
        // różnica w milisekundach
        const diffTime = new Date(metaDataCamp.date_from).getTime() - today.getTime();
        // różnica w dniach (zaokrąglona w dół)
        const daysDiff = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        if (daysDiff > 35) {
          toShowPromotionFields.push('quick_payment_promotion');
        }
      }

      // Zaznaczając KDR musimy schować wszystkie inne promocje
      if (optionIndex === 1) {
        hideFieldsCallback(sectionId, toHidepromotionFields, [], sections);
      } else {
        // Pokazujemy z powrotem
        hideFieldsCallback(sectionId, [], toShowPromotionFields, sections);
      }
    }
  };

  const updateDiscountsCallback = (discount, sectionId, discountArr, promId = null) => {
    if (promId) {
      return _.filter(metaData.promotions, prom => prom.id == promId)[0];
    }
    const sectionsToConst = _.cloneDeep(sections);
    const section = _.filter(sectionsToConst, section => section.id === sectionId)[0];
    const index = sectionsToConst.indexOf(section);
    sectionsToConst.splice(index, 1);
    _.map(section.fields, field => {
      if (field.name === 'discount') {
        if (field.dynamicOptions) {
          field.dynamicOptions = [...field.dynamicOptions, discount];
        } else {
          field.dynamicOptions = [discount];
        }
      }
    });
    sectionsToConst.splice(index, 0, section);
    setSections(sectionsToConst);
    handleDiscountActions(discountArr, sectionId, sectionsToConst);
  };

  const historicDataByPeselCallback = async pesel => {
    const { loading, payload, error } = await historicPeselAction.query(pesel);
    if (!loading, !error) {
      if (payload.count == 0) {
        return;
      }
      // eslint-disable-next-line no-alert
      const result = confirm(`Znaleziono ${payload.count} zamówień z podanym numerem pesel. Czy wczytać dane?`);
      if (result == true) {
        _.map(payload, (value, key) => {
          formik.setFieldValue(key, value);
        });
      };
    }
  };

  const checkActivitiesCallback = (action, item, field, currentValues) => {
    const period = sections[0].fields.find(x => x.name == 'period').dynamicOptions.find(x => x.id == formik.values.period);
    if ((/^202[456789]/).test(form.version.toString())) {
      // Sezon 2024+:
      const mainActivitiesMax = period.main_activities_count;
      const ropeActivitiesMax = period.rope_activities_count;
      const educationalActivitiesMax = period.educational_activities_count;
      const entertainmentActivitiesMax = period.entertainment_activities_count;
      const integrationActivitiesMax = period.integration_activities_count;
      const summaryMax = mainActivitiesMax;
      let currentMainActivities = 0;
      let currentRopeActivities = 0;
      let currentEducationalActivities = 0;
      let currentEntertainmentActivities = 0;
      let currentIntegrationActivities = 0;
      // eslint-disable-next-line guard-for-in
      for (const idx in currentValues) {
        const obj = field.dynamicOptions.find(x => x.id == currentValues[idx]);
        if (obj.type == 'rope_activity') {
          currentRopeActivities += 1;
        } else if (obj.type == 'educational') {
          currentEducationalActivities += 1;
        } else if (obj.type == 'entertainment') {
          currentEntertainmentActivities += 1;
        } else if (obj.type == 'integration') {
          currentIntegrationActivities += 1;
        } else {
          currentMainActivities += 1;
        }
      }
      if (action == 'add') {
        if (currentMainActivities + currentRopeActivities + currentEducationalActivities + currentEntertainmentActivities + currentIntegrationActivities >= summaryMax) {
          return { error: true, message: `Proszę wybrać maksymalnie ${currentMainActivities + currentRopeActivities + currentEducationalActivities + currentEntertainmentActivities + currentIntegrationActivities} zajęć / ${summaryMax} zajęć`, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, currentEntertainmentActivities, entertainmentActivitiesMax, currentIntegrationActivities, integrationActivitiesMax };
        }
        // if (currentRopeActivities >= ropeActivitiesMax && item.type == 'rope_activity') {
        //   return { error: true, message: `Prosimy wybrać maksymalnie ${currentRopeActivities}/${ropeActivitiesMax} zajęcie linowe`, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, currentEntertainmentActivities, entertainmentActivitiesMax, currentIntegrationActivities, integrationActivitiesMax };
        // }
        if (currentEducationalActivities >= educationalActivitiesMax && item.type == 'educational') {
          return { error: true, message: `Prosimy wybrać maksymalnie ${currentEducationalActivities}/${educationalActivitiesMax} zajęć edukacyjnych`, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, currentEntertainmentActivities, entertainmentActivitiesMax, currentIntegrationActivities, integrationActivitiesMax };
        }
        if (currentEntertainmentActivities >= entertainmentActivitiesMax && item.type == 'entertainment') {
          return { error: true, message: `Prosimy wybrać maksymalnie ${currentEntertainmentActivities}/${entertainmentActivitiesMax} zajęć rozrywkowych`, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, currentEntertainmentActivities, entertainmentActivitiesMax, currentIntegrationActivities, integrationActivitiesMax };
        }
        if (currentIntegrationActivities >= integrationActivitiesMax && item.type == 'integration') {
          return { error: true, message: `Prosimy wybrać maksymalnie ${currentIntegrationActivities}/${integrationActivitiesMax} zajęć integracyjnych`, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, currentEntertainmentActivities, entertainmentActivitiesMax, currentIntegrationActivities, integrationActivitiesMax };
        }
        if (item.type == 'rope_activity') {
          currentRopeActivities += 1;
        } else if (item.type == 'educational') {
          currentEducationalActivities += 1;
        } else if (item.type == 'entertainment') {
          currentEntertainmentActivities += 1;
        } else if (item.type == 'integration') {
          currentIntegrationActivities += 1;
        } else {
          currentMainActivities += 1;
        }

        return { error: false, message: '', currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, currentEntertainmentActivities, entertainmentActivitiesMax, currentIntegrationActivities, integrationActivitiesMax };
      }
      if (item.type == 'rope_activity') {
        currentRopeActivities -= 1;
      } else if (item.type == 'educational') {
        currentEducationalActivities += 1;
      } else if (item.type == 'entertainment') {
        currentEntertainmentActivities -= 1;
      } else if (item.type == 'integration') {
        currentIntegrationActivities -= 1;
      } else {
        currentMainActivities -= 1;
      }

      return { currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, currentEntertainmentActivities, entertainmentActivitiesMax, currentIntegrationActivities, integrationActivitiesMax };
    }
    // Sezon 2023:
    const mainActivitiesMax = period.main_activities_count;
    const ropeActivitiesMax = period.rope_activities_count;
    const educationalActivitiesMax = period.educational_activities_count;
    const summaryMax = mainActivitiesMax + ropeActivitiesMax + educationalActivitiesMax;
    let currentMainActivities = 0;
    let currentRopeActivities = 0;
    let currentEducationalActivities = 0;
    let artisticActivityIsPresent = 0;
    // eslint-disable-next-line guard-for-in
    for (const idx in currentValues) {
      const obj = field.dynamicOptions.find(x => x.id == currentValues[idx]);
      if (obj.type == 'rope_activity') {
        currentRopeActivities += 1;
      } else if (obj.type == 'educational') {
        currentEducationalActivities += 1;
      } else if (obj.type == 'artistic') {
        artisticActivityIsPresent = 1;
      } else {
        currentMainActivities += 1;
      }
    }
    if (action == 'add') {
      if (currentMainActivities + currentRopeActivities + currentEducationalActivities + artisticActivityIsPresent >= summaryMax) {
        return { error: true, message: `Proszę wybrać maksymalnie ${currentMainActivities + currentRopeActivities + currentEducationalActivities + artisticActivityIsPresent} zajęć / ${summaryMax} zajęć`, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, artisticActivityIsPresent };
      }
      // if (currentRopeActivities >= ropeActivitiesMax && item.type == 'rope_activity') {
      //   return { error: true, message: `Prosimy wybrać maksymalnie ${currentRopeActivities}/${ropeActivitiesMax} zajęcie linowe`, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, artisticActivityIsPresent };
      // }
      if (currentEducationalActivities >= educationalActivitiesMax && item.type == 'educational') {
        return { error: true, message: `Prosimy wybrać maksymalnie ${currentEducationalActivities}/${educationalActivitiesMax} zajęć edukacyjnych`, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, artisticActivityIsPresent };
      }
      if (artisticActivityIsPresent > 0 && item.type == 'artistic') {
        return { error: true, message: 'Wybrano już jedno zajęcie artystyczne', currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, artisticActivityIsPresent };
      }

      if (item.type == 'rope_activity') {
        currentRopeActivities += 1;
      } else if (item.type == 'educational') {
        currentEducationalActivities += 1;
      } else if (item.type == 'artistic') {
        artisticActivityIsPresent = 1;
      } else {
        currentMainActivities += 1;
      }

      return { error: false, message: '', currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, artisticActivityIsPresent };
    }
    if (item.type == 'rope_activity') {
      currentRopeActivities -= 1;
    } else if (item.type == 'educational') {
      currentEducationalActivities += 1;
    } else if (item.type == 'artistic') {
      artisticActivityIsPresent = 0;
    } else {
      currentMainActivities -= 1;
    }

    return { currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, artisticActivityIsPresent };
  };

  const setDateToCallback = date => {
    const period = sections[0].fields.find(x => x.name == 'period').dynamicOptions.find(x => x.id == formik.values.period);
    if (period.is_weekend && date.getDay() !== 5) {
      alert('Wybrano termin weekendowy. Należy zaznaczyć piątek.');
      formik.setFieldValue('period_to', null);
    } else if (period.days_count == 3 && (date.getDay() !== 1 && date.getDay() !== 3 && date.getDay() !== 5)) {
      alert('Wycieczki 3-dniowe zaczynają się od poniedziałku, środy bądź piątku.');
      formik.setFieldValue('period_to', null);
    } else if (period.days_count == 3 && date.getDay() >= 1 && date.getMonth() == 9) {
      alert('Proszę wybrać datę minimalnie o 3 dni mniejszą od 4 września');
      formik.setFieldValue('period_to', null);
    } else if (period.days_count == 5 && ((date.getDay() >= 30 && date.getMonth() == 8) || (date.getDay() >= 1 && date.getMonth() == 9))) {
      alert('Proszę wybrać datę minimalnie o 5 dni mniejszą od 4 września');
      formik.setFieldValue('period_to', null);
    } else if (period.days_count == 5 && date.getDay() >= 18 && date.getMonth() == 5) {
      alert('Proszę wybrać datę minimalnie o 3 dni mniejszą od 21 czerwca');
      formik.setFieldValue('period_to', null);
    } else if (period.days_count == 5 && date.getDay() >= 16 && date.getMonth() == 5) {
      alert('Proszę wybrać datę minimalnie o 5 dni mniejszą od 21 czerwca');
      formik.setFieldValue('period_to', null);
    } else {
      formik.setFieldValue('period_from', formatDate(date));
      formik.setFieldValue('period_to', formatDate(addDays(date, period.days_count - 1)));
      formik.setFieldValue('discount', [null, null, null, null, null, null]);
    }
  };

  const hideFieldCallback = (fieldName, sectionId, reverse, required = false) => {
    const sectionsToConst = _.cloneDeep(sections);
    const fieldsToConst = _.cloneDeep(fields);
    const section = _.filter(sectionsToConst, section => section.id === sectionId)[0];
    const index = sectionsToConst.indexOf(section);
    sectionsToConst.splice(index, 1);
    _.map(section.fields, field => {
      if (field.name === fieldName) {
        const yupField = _.find(fieldsToConst, obj => obj.id === field.id);
        if (reverse) {
          yupField.hide = false;
          yupField.required = required;
        } else {
          yupField.hide = true;
          yupField.required = required;
          formik.setFieldValue(fieldName, '');
        }
        if (required) {
          yupField.validations.push({ type: 'required', params: ['To pole jest wymagane'] });
          if (field.type == 'bool') {
            yupField.validations.push({ type: 'oneOf', params: [[true], 'Należy zaakceptować warunki'] });
          }
        } else {
          yupField.validations = _.filter(field.validations, obj => obj.type !== 'required');
        }
        field.hide = yupField.hide;
        field.required = yupField.required;
        field.validations = yupField.validations;
      }
    });
    sectionsToConst.splice(index, 0, section);
    setSections(sectionsToConst);
    setFields(fieldsToConst);
  };

  const hideFieldsCallback = (
    sectionIdOrIds,
    toHideFieldNames = [],
    toShowFieldNames = [],
    newSections = null,
    requiredHideFieldNames = [],
    requiredShowFieldNames = []
  ) => {
    let sectionsToConst = _.cloneDeep(sections);
    const fieldsToConst = _.cloneDeep(fields);
    if (newSections) {
      sectionsToConst = newSections;
    }

    const sectionIds = Array.isArray(sectionIdOrIds) ? sectionIdOrIds : [sectionIdOrIds];

    sectionIds.forEach(sectionId => {
      const section = sectionsToConst.find(section => section.id === sectionId);
      if (!section) {
        return;
      }

      const index = sectionsToConst.indexOf(section);
      sectionsToConst.splice(index, 1);

      // Ukrywamy pola
      toHideFieldNames.forEach(fieldName => {
        section.fields.forEach(field => {
          if (field.name === fieldName) {
            field.hide = true;

            // Reset wartości
            if (['siblings', 'friends', 'additionally_paid_activities_json', 'team_promotion'].includes(fieldName)) {
              formik.setFieldValue(fieldName, [{}]);
            } else if (fieldName === 'friends_promotion_choice') {
              formik.setFieldValue(fieldName, 'Chcę otrzymać rabat');
            } else if (['main_activities', 'discount_code_promotions'].includes(fieldName)) {
              formik.setFieldValue(fieldName, []);
            } else if (field.type === 'bool') {
              formik.setFieldValue(fieldName, false);
            } else if (fieldName === 'ol_discounts') {
              formik.setFieldValue(fieldName, [null, null, null, null, null]);
            } else {
              formik.setFieldValue(fieldName, '');
            }

            // Obsługa pola required
            field.required = requiredHideFieldNames.includes(fieldName) ? false : field.required;
            field.validations = requiredHideFieldNames.includes(fieldName)
              ? []
              : field.validations;

            const yupField = fieldsToConst.find(f => f.id === field.id);
            if (yupField) {
              yupField.hide = true;
              yupField.required = field.required;
              yupField.validations = field.validations;
            }
          }
        });
      });

      // Pokazujemy pola
      toShowFieldNames.forEach(fieldName => {
        section.fields.forEach(field => {
          if (field.name === fieldName) {
            field.hide = false;

            // Obsługa pola required
            if (requiredShowFieldNames.includes(fieldName)) {
              field.required = true;
              if (!field.validations.find(v => v.type === 'required')) {
                field.validations.push({ type: 'required', params: ['To pole jest wymagane'] });
              }
              if (field.type == 'multichoice') {
                field.validations.push({ type: 'min', params: [1, 'Proszę podać conajmniej 1 element z listy'] });
              }
              if (field.type === 'multichar') {
                // minimum 1 wiersz
                if (!field.validations.find(v => v.type === 'minRows')) {
                  field.validations.push({
                    type: 'minRows',
                    params: [1, 'Proszę dodać przynajmniej jeden element']
                  });
                }

                // required subfields
                if (!field.validations.find(v => v.type === 'requiredRows')) {
                  field.validations.push({
                    type: 'requiredRows',
                    params: ['Wszystkie pola w wierszu są wymagane']
                  });
                }
              }
            }

            const yupField = fieldsToConst.find(f => f.id === field.id);
            if (yupField) {
              yupField.hide = false;
              yupField.required = field.required;
              yupField.validations = field.validations;
            }
          }
        });
      });

      sectionsToConst.splice(index, 0, section);
    });

    setSections(sectionsToConst);
    setFields(fieldsToConst);
  };


  const handleDiscountActions = (ids, sectionId, sections) => {
    const toHideFieldNames = [];
    const toShowFieldNames = [];
    const proms = _.filter(metaData.promotions, prom => ids.includes(prom.id.toString()) || ids.includes(prom.id));
    if (_.isEmpty(proms)) {
      toHideFieldNames.push('friends', 'friends_promotion_choice', 'siblings', 'has_big_family_card', 'team_promotion');
      hideFieldsCallback(sectionId, toHideFieldNames, toShowFieldNames, sections);

      return;
    }
    if (proms.some(prom => prom.for_friend)) {
      toShowFieldNames.push('friends', 'friends_promotion_choice');
    } else {
      toHideFieldNames.push('friends', 'friends_promotion_choice');
    }
    const connectedProms = _.filter(proms, prom => prom.is_connected_with_big_family_card);
    const showBigFamilyCard = connectedProms.length === proms.length;
    if (showBigFamilyCard && !formik.values.boskie_wakacje) {
      if (!metaData.allow_more_than_2_promotions_selected) {
        // Pokazujemy tylko gdy jest wybrana 1 promocja lub 1 promocja i 1 rabat
        if (proms.length == 2) {
          const prom2 = proms[1];
          const prom1 = proms[0];
          if (prom2.discount_code || prom1.discount_code) {
            toShowFieldNames.push('has_big_family_card');
          } else {
            toHideFieldNames.push('has_big_family_card');
          }
        } else if (proms.length == 1) {
          // Gdy mamy 1 promocje to pokazujemy
          toShowFieldNames.push('has_big_family_card');
        } else {
          // To w przypadku kiedy jest więcej niż dwie promocje
          toHideFieldNames.push('has_big_family_card');
        }
      } else {
        toShowFieldNames.push('has_big_family_card');
      }
    } else {
      toHideFieldNames.push('has_big_family_card');
    }
    if (proms.some(prom => prom.for_siblings)) {
      toShowFieldNames.push('siblings');
    } else {
      toHideFieldNames.push('siblings');
    }
    if (proms.some(prom => prom.for_team)) {
      toShowFieldNames.push('team_promotion');
    } else {
      toHideFieldNames.push('team_promotion');
    }
    hideFieldsCallback(sectionId, toHideFieldNames, toShowFieldNames, sections);
  };

  const handleOLDiscountActions = (ids, sectionId, sections) => {
    const toHideFieldNames = [];
    const toShowFieldNames = [];
    const requiredHideFieldNames = [];
    const requiredShowFieldNames = [];
    const proms = _.filter(metaData.promotions, prom => ids.includes(prom.id.toString()) || ids.includes(prom.id));
    if (_.isEmpty(proms)) {
      toHideFieldNames.push('friends', 'friends_promotion_choice', 'siblings', 'team_promotion');
      requiredHideFieldNames.push('siblings', 'friends', 'team_promotion');
      hideFieldsCallback(sectionId, toHideFieldNames, toShowFieldNames, sections, requiredHideFieldNames, requiredShowFieldNames);

      return;
    }
    if (proms.some(prom => prom.for_friend)) {
      toShowFieldNames.push('friends', 'friends_promotion_choice');
      requiredShowFieldNames.push('friends');
    } else {
      toHideFieldNames.push('friends', 'friends_promotion_choice');
      requiredHideFieldNames.push('friends');
    }
    if (proms.some(prom => prom.for_siblings)) {
      toShowFieldNames.push('siblings');
      requiredShowFieldNames.push('siblings');
    } else {
      toHideFieldNames.push('siblings');
      requiredHideFieldNames.push('siblings');
    }
    if (proms.some(prom => prom.for_team)) {
      toShowFieldNames.push('team_promotion');
      requiredShowFieldNames.push('team_promotion');
    } else {
      toHideFieldNames.push('team_promotion');
      requiredHideFieldNames.push('team_promotion');
    }
    hideFieldsCallback(sectionId, toHideFieldNames, toShowFieldNames, sections, requiredHideFieldNames, requiredShowFieldNames);
  };


  const handleParishChange = (id, sectionId) => {
    const parish = _.filter(metaData.parishes, p => id == p.id)[0];
    if (parish && parish.name.includes('Inne')) {
      hideFieldCallback('parish_other', sectionId, true, true);
    } else {
      hideFieldCallback('parish_other', sectionId, false, false);
    }
  };

  const handleEventChange = (val, sectionId) => {
    if (form.identifier === 'polkolonie') {
      const event = _.filter(metaData.events, event => event.id == val)[0];
      if (event && event.canoeing_activities) {
        hideFieldCallback('canoeing_activities', sectionId, true, true);
      } else {
        hideFieldCallback('canoeing_activities', sectionId, false, false);
      }
    } else if (form.identifier === 'lato') {
      const event = _.filter(metaData.events, event => event.id == val)[0];
      if (event && event.name.toUpperCase().includes('NATIVE SPEAKEREM')) {
        hideFieldCallback('child_english_communicative', sectionId, true, true);
      } else {
        hideFieldCallback('child_english_communicative', sectionId, false, false);
      }
    }
  };

  const handlePeriodChange = (v, sectionId, sSections, initialization = false) => {
    let sectionIds = sectionId;
    const driverOnResortSectionId = sections.find(s => s.fields.some(f => f.name === 'driver_on_resort')
    )?.id;
    if (driverOnResortSectionId) {
      sectionIds = [sectionId, driverOnResortSectionId];
    }
    if (v.props.id.includes('1 DZIEŃ') || v.props.id.includes('1-DNIOWE')) {
      if (v.props.id.includes('SUNMAGEDON') || v.props.id.includes('ARENA NINJA')) {
        hideFieldsCallback(sectionIds, ['educational_trip', 'paintball_participants_count', 'optional_activity_count_2', 'optional_activity_count_1', 'optional_activity_count_3', 'package', 'driver_on_resort'], [], sSections);
      } else {
        hideFieldsCallback(sectionIds, ['educational_trip', 'paintball_participants_count', 'optional_activity_count_2', 'main_activities', 'additionally_paid_activities_json'], ['optional_activity_count_1', 'optional_activity_count_3', 'package', 'driver_on_resort'], sSections, ['main_activities'], ['package']);
      }
    } else if (v.props.id.includes('3 DNI') || v.props.id.includes('5 DNI') || v.props.id.includes('WEEKEND')) {
      const resort = _.filter(metaData.resorts, r => r.id == formik.values.resort)[0];
      if (resort.name == 'GIEWARTÓW') {
        hideFieldsCallback(sectionIds, ['educational_trip', 'paintball_participants_count', 'optional_activity_count_2', 'optional_activity_count_3', 'package', 'driver_on_resort'], ['optional_activity_count_1', 'main_activities', 'additionally_paid_activities_json'], sSections, ['package'], ['main_activities']);
      } else {
        hideFieldsCallback(sectionIds, ['educational_trip', 'paintball_participants_count', 'optional_activity_count_3', 'package', 'driver_on_resort'], ['optional_activity_count_1', 'optional_activity_count_2', 'main_activities', 'additionally_paid_activities_json'], sSections, ['package'], ['main_activities']);
      }
    } else {
      hideFieldsCallback(sectionIds, ['optional_activity_count_1', 'optional_activity_count_2', 'optional_activity_count_3', 'package', 'driver_on_resort'], ['educational_trip', 'paintball_participants_count', 'main_activities', 'additionally_paid_activities_json'], sSections, ['package'], ['main_activities']);
    }
    if (!initialization) {
      formik.setFieldValue('period_from', null);
      formik.setFieldValue('period_to', null);
    }
  };

  const handleSourceOfOfferChange = (obj, sectionId) => {
    if ((/^202[456789]/).test(form.version.toString())) {
      if (obj.name.toLowerCase().includes('jestem stałym klientem')) {
        hideFieldsCallback(sectionId, ['source_of_offer_additional_info_2'], ['source_of_offer_additional_info'], null);
      } else if (obj.name.toLowerCase().includes('inne')) {
        hideFieldsCallback(sectionId, ['source_of_offer_additional_info'], ['source_of_offer_additional_info_2'], null);
      } else {
        hideFieldsCallback(sectionId, ['source_of_offer_additional_info', 'source_of_offer_additional_info_2'], [], null);
      }
    }
  };

  const handleAccomodationChange = (value, field) => {
    if (form.identifier == 'wyjazdy_rodzinne') {
      const maxSlots = field.dynamicOptions.find(o => o.id == value).slots_count;
      let currentSlots = parseInt(formik.values.wr_adults_count);
      currentSlots += formik.values.wr_0_3_children_count?.length || 0;
      currentSlots += formik.values.wr_3_12_children_count?.length || 0;
      currentSlots += formik.values.wr_6_plus_children_count?.length || 0;
      currentSlots += formik.values.wr_0_5_children_count?.length || 0;
      if (currentSlots > maxSlots) {
        formik.setFieldValue(field.name, '');
        alert(`To zakwaterowanie przeznaczone jest dla maksymalnie ${maxSlots} osób.`);
      }

    }
  };

  useDidMountEffect(() => {
    setShowErrors(true);
  }, [formik.isSubmitting]);

  if (_.isEmpty(formik.values) || metaLoading) {
    return <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '300px',
        flexDirection: 'column'
      }}
    >
      <CircularProgress size={160} />
      <Typography variant="h6" mt={4}>Wczytujemy formularz...</Typography>
    </Box>;
  }

  return (
    <Card elevation={4} sx={{ opacity: '0.95', mt: 2 }}>
      <CardContent>
        {isFormSent
          ? <FormSentInfo formId={form.id} identifier={form.identifier} formikValues={formik.values}/>
          : <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}>
            {formSteps.length > 0 && <Stack
              direction={!fullScreen ? 'row' : 'column'}
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              mb={4}
              spacing={!fullScreen ? 0 : 2}
            >
              <Box
                component="img"
                src={!fullScreen ? '/static/formularz-rezerwacji-desktop.png' : '/static/formularz-rezerwacji-mobile.png'}
                sx={{ objectFit: 'contain' }} />
              <FormStepper activeStep={activeStep} steps={formSteps} isMobile={fullScreen} />
            </Stack>}
            {'resort' in params ? <Typography align="center" variant="h3">Aby formularz się wypełnił należy podać datę urodzenia aby upewnić się, że jest ona poprawna dla wybranej imprezy.</Typography> : null}

            {_.map(sections, (obj, idx) => 'resort' in params && idx > 0 && metaData.events && (!sections[1].fields[0].dynamicOptions || sections[1].fields[0].dynamicOptions.length == 0) ? null : (
              <Box style={{ flex: !fullScreen ? numberToPercent(obj.flex) : '100%' }} key={idx}>
                <SectionPanel
                  section={obj}
                  formik={formik}
                  formVersion={form.version}
                  formIdentifier={form.identifier}
                  updateOptionsCallback={updateOptionsCallback}
                  yupRequiredFieldsCallback={yupRequiredFieldsCallback}
                  bigFamilyCardCallback={bigFamilyCardCallback}
                  updateDiscountsCallback={updateDiscountsCallback}
                  historicDataByPeselCallback={historicDataByPeselCallback}
                  checkActivitiesCallback={checkActivitiesCallback}
                  setDateToCallback={setDateToCallback}
                  hideFieldCallback={hideFieldCallback}
                  handleDiscountActions={handleDiscountActions}
                  handleOLDiscountActions={handleOLDiscountActions}
                  handleParishChange={handleParishChange}
                  handleEventChange={handleEventChange}
                  handlePeriodChange={handlePeriodChange}
                  handleSourceOfOfferChange={handleSourceOfOfferChange}
                  params={params}
                  boskieWakacje={boskieWakacje}
                  allowMoreThan2PromotionsSelected={metaData.allow_more_than_2_promotions_selected}
                  initialParamsData={initialParamsData}
                  handleAccomodationChange={handleAccomodationChange}
                  searchParams={searchParams}
                  events={metaData.events}
                  sections={sections}
                  metaData={metaData}
                  hideFieldsCallback={hideFieldsCallback}
                  activeStep={activeStep}
                />
              </Box>
            ))}
            {formSteps.length == 0 ? <Box sx={{
              display: 'flex',
              gap: 2,
              mt: 2,
              mb: 2
            }}>
              <Button
                color="secondary"
                variant="contained"
                type="submit"
                endIcon={<SendIcon />}
                disabled={submitForm.loading}
                size="large"
              >
                Zatwierdź i wyślij
              </Button>
            </Box> : activeStep === formSteps.length ? <Box textAlign="center">
              <button
                data-cy="test-cypress-submit"
                type="button"
                style={{ display: 'none' }}
                onClick={() => formik.setFieldValue('testForm', true)}
              >
                Przycisk testowy
              </button>
              <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                  mt: 2,
                  mb: 2
                }}
              >
                <Button
                  color="inherit"
                  variant="outlined"
                  disabled={submitForm.loading || activeStep === 1}
                  onClick={goToPreviousStep}
                  size="large"
                >
                  WRÓĆ DO KROKU {activeStep - 1}: {formSteps[activeStep - 1]?.label.toUpperCase()}
                </Button>

                <Button
                  color="secondary"
                  variant="contained"
                  type="submit"
                  endIcon={<SendIcon />}
                  disabled={submitForm.loading}
                  size="large"
                >
                Zatwierdź i wyślij
                </Button>
              </Box>
            </Box>
              : <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                  mt: 2,
                  mb: 2
                }}
              >
                {activeStep > 1 && <Button
                  color="inherit"
                  variant="outlined"
                  disabled={submitForm.loading}
                  onClick={goToPreviousStep}
                  size="large"
                >
                  WRÓĆ DO KROKU {activeStep - 1}: {formSteps[activeStep - 1]?.label.toUpperCase()}
                </Button>}

                <Button
                  color="secondary"
                  variant="contained"
                  disabled={submitForm.loading}
                  onClick={goToNextStep}
                  size="large"
                >
                  IDŹ DO KROKU {activeStep + 1}: {formSteps[activeStep].label.toUpperCase()}
                </Button>
              </Box>
            }
          </form>}
        { showErrors
          ? <>
            {_.map(formik.errors, (v, k) => {
              const field = fields.find(
                field => field.step === activeStep && field.name === k
              );

              if (!field) {
                return null;
              }

              return (
                <span key={k}>
                  <Typography variant="body1" color="error">
                    <b>{field.label} - <u>{v}</u></b>
                  </Typography>
                </span>
              );
            })}
          </> : null
        }
      </CardContent>
    </Card>
  );
};
